export default "__VITE_ASSET__ujk53dl$__"